import { localize } from "utils/localizer";

const i18n = {
    address: {
        en: "Address",
        de: "Anschrift",
    },
    generalSettings: {
        en: "Company Settings",
        de: "Firmeneinstellungen",
    },
    memberSettings: {
        en: "Member Settings",
        de: "Mitgliedereinstellungen",
    },
    save: {
        en: "Save",
        de: "Speichern",
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    savedSuccessfully: {
        en: "Saved successfully",
        de: "Erfolgreich gespeichert",
    },
    applyToCurrentMonth: {
        en: "Apply to current month",
        de: "Auf laufenden Monat anwenden",
    },
    currentMonthUsedBudget: {
        en: "Current month used budget",
        de: "Verwendetes Budget laufender Monat",
    },
    previousMonthUsedBudget: {
        en: "Previous month used budget",
        de: "Verwendetes Budget des Vormonats",
    },
    defaultMonthlyCompanyBudget: {
        en: "Default monthly company budget",
        de: "Monatliches standardmäßiges Guthaben pro Mitarbeiter*in",
    },
    defaultMonthlyMemberBudget: {
        en: "Default monthly member budget",
        de: "Monatliches standardmäßiges Guthaben pro Mitarbeiter*in",
    },
    monthlyCompanyTotalBudget: {
        en: "Monthly company total budget",
        de: "Monatliches Gesamtbudget des Unternehmens",
    },
    aliasAccount: {
        en: "Alias Account",
        de: "Alias Account",
    },
    firstName: {
        en: "First Name",
        de: "Vorname",
    },
    lastName: {
        en: "Last Name",
        de: "Nachname",
    },
    emailAddress: {
        en: "E-Mail Address",
        de: "E-Mail-Adresse",
    },
    bulkEdit: {
        en: "Bulk Edit",
        de: "Guthabenverarbeitung",
    },
    edit: {
        en: "Edit",
        de: "Ändern",
    },
    cancel: {
        en: "Cancel",
        de: "Abbrechen",
    },
    execute: {
        en: "Execute",
        de: "Durchführen",
    },
    affectedEntries: {
        en: (x: number) => `${x} affected entries`,
        de: (x: number) => `${x} betroffene Einträge`,
    },
    query: {
        en: "Query",
        de: "Suchanfrage",
    },
    monthlyCompanyMemberBudgetCents: {
        en: "Monthly company member budget",
        de: "Monatliches Guthaben pro Mitarbeiter*in",
    },
    company: {
        en: "Company",
        de: "Begleitung",
    },
    date: {
        en: "Date",
        de: "Datum",
    },
    month: {
        en: "Month",
        de: "Monat",
    },
    totalMemberBudget: {
        en: "Total Member Budget",
        de: "Gesamtbudget der Mitglieder",
    },
    usedMemberBudget: {
        en: "Used Member Budget",
        de: "Verwendetes Guthaben",
    },
    applyToCurrentMonthAlert: {
        en: "Members who have already used more than the new default budget will be adjusted according to the max rule. i.e. current month's budget to be maximum of the new default member budget and the already used budget.",
        de: "Mitglieder, die bereits mehr als das neue Standardbudget verbraucht haben, werden entsprechend der Max-Regel angepasst. d.h. das Budget des aktuellen Monats darf maximal aus dem neuen Standard-Mitgliedsbudget und dem bereits verwendeten Budget bestehen.",
    },
    warning: {
        en: "Warning",
        de: "Warnung",
    },
    noActivePlanErrorMsg: {
        en: "Attention: The settings only become active when a subscription has started.",
        de: "Achtung: Die Einstellungen werden erst bei Abschluss eines Abonnements aktiv.",
    },
    subscriptionPlan: {
        en: "Click here to choose a plan",
        de: "Klicken Sie hier, um einen Plan auszuwählen",
    },
    monthlyCompanyTotalBudgetInfoDesc: {
        en: "This monthly maximum budget is used for cost control. If it is used up, employees can no longer use their available budget for the rest of the month.",
        de: "Dieses monatliche Maximalbudget dient der Kostenkontrolle. Ist es aufgebraucht, können Mitarbeiter*innen ihr noch verfügbares Budget für den Rest des Monats nicht mehr nutzen.",
    },
    yes: {
        en: "Yes",
        de: "Ja",
    },
    no: {
        en: "No",
        de: "Nein",
    },
    warningMsgFordefaultMonthlyCompanyBudgetChange: {
        en: "This monthly Credit is available to all employees who are newly entered into the system. This means that the entire PLAYSPORTS world can be used and sports fields and events of your choice can be booked - you only pay for what has been used.",
        de: "Dieses mtl. Guthaben steht allen Mitarbeiter*innen zur Verfügung, die neu in das System eingepflegt werden. Damit kann die gesamte PLAYSPORTS-Welt genutzt und Sportplätze und Events der Wahl gebucht werden – Sie zahlen nur, was genutzt wurde.",
    },
    warningMsgForCompanyBudgetChange: {
        en: "Employees could already have used more budget then the new default balance. This will still be billed. In the next month, all assistants have the same credit available again.",
        de: "Mitarbeiterinnen könnten bereits mehr als das neue Standardguthaben verbraucht haben. Dieses wird trotzdem abgerechnet. Im nächsten Monat haben alle Mitarbeiterinnen wieder das gleiche Guthaben zu verfügung.",
    },
    warningMsgForCompanyMemberBudgetChange: {
        en: "The employee may have already used up more than the new credit. This will still be billed.",
        de: "Die Mitarbeiterin bzw. der Mitarbeiter könnte bereits mehr als das neue Guthaben verbraucht haben. Dieses wird trotzdem abgerechnet.",
    },
    warningMsgTitle: {
        en: "Warning",
        de: "Warnung",
    },
    confirmMsgForCompanyBugetChange: {
        en: "Would you like to update?",
        de: "Möchten Sie das Guthaben anpassen?",
    },
    warningMsgForChangedBudget: {
        en: "Should the new credit be valid from this month?",
        de: "Soll das neue Guthaben bereits ab diesem Monat gelten?",
    },
    confirm: {
        en: "Confirm",
        de: "Bestätigen",
    },
    budgetSettings: {
        en: "Budget Settings",
        de: "Budgeteinstellungen",
    },
    invoiceSettings: {
        en: "Invoice Settings",
        de: "Rechnungseinstellungen",
    },
    companyName: {
        en: "Company Name",
        de: "Name der Firma",
    },
    addressLine1: {
        en: "Address Line1",
        de: "Anschrift Zeile 1",
    },
    addressLine2: {
        en: "Address Line2",
        de: "Anschrift Zeile 2",
    },
    city: {
        en: "City",
        de: "Stadt",
    },
    state: {
        en: "State",
        de: "Bundesland",
    },
    postCode: {
        en: "Post Code",
        de: "PLZ",
    },
    country: {
        en: "Country",
        de: "Land",
    },
    upComing: {
        en: "Upcoming (to-date)",
        de: "Nächste Rechnung (Stand heute)",
    },
    email: {
        en: "Billing E-Mail",
        de: "Rechnungs-E-Mail",
    },
    invoiceSettingsButton: {
        en: "Save Invoice Settings",
        de: "Rechnungseinstellungen speichern",
    },
    totalBudget: {
        en: "Total Budget",
        de: "Gesamtbudget; Gesamtetat",
    },
    usedBudget: {
        en: "Used Budget",
        de: "Genutztes Budget",
    },
    budgetHistory: {
        en: "Budget History",
        de: "Budgetverlauf",
    },
    memberBudgets: {
        en: "Member Budgets",
        de: "Mitgliederbudget",
    },
    site: {
        en: "Site",
        de: "Standort",
    },
    companyMemberBudget: {
        en: "Company Member Budget",
        de: "Mtl. Guthaben",
    },
    organisation: {
        en: "Organisation",
        de: "Organisation",
    },
    usedBudgetExceedsMonthlyTotalBudgetErrorMsg: {
        en: "The total monthly budget is smaller than the used budget by the employees. The new total budget is valid only from the next month even if you apply in current month.",
        de: "Das monatliche Gesamtbudget ist kleiner als das bereits verbrauchte Budget in diesem Monat durch die Mitarbeiter*innen. Das neue Gesamtbudget gilt deswegen erst ab dem nächsten Monat.",
    },
    alert: {
        en: "Alert",
        de: "Achtung",
    },
    close: {
        en: "Close",
        de: "schließen",
    },
    warningMsgForPassword: {
        en: "The password must contain a capital letter and be at least 8 characters long.",
        de: "Das Passwort muss einen Großbuchstaben enthalten und mindestens 8 Zeichen lang sein.",
    },
    fileTooLarge: {
        en: "The file size may not exceed 3 MB",
        de: "Die Datei darf nicht größer als 3 MB sein",
    },
    invalidImageFile: {
        en: "Invalid image file, allowed types are image/png, image/jpg, image/jpeg, image/gif",
        de: "Ungültige Bilddatei, zulässige Typen sind image/png, image/jpg, image/jpeg, image/gif",
    },
    videoFileTooLarge: {
        en: "The file size may not exceed 100 MB",
        de: "Die Datei darf nicht größer als 100 MB sein",
    },
    invalidVideoFile: {
        en: "Invalid video file, allowed types are video/quicktime, video/mp4, video/wmv",
        de: "Ungültige videodatei, zulässige Typen sind video/quicktime, video/mp4, video/wmv",
    },
    deletedSuccessfully: {
        en: "Successfully deleted",
        de: "Erfolgreich gelöscht",
    },
    profileInformation: {
        en: "Company profile",
        de: "Unternehmensprofil",
    },
    galleryMedia: {
        en: "Gallery Media",
        de: "Galerie Bilder",
    },
    mediaItem: {
        en: "Describe your business with a video",
        de: "Beschreibe dein Unternehmen mit einem Video",
    },
    changeProfilePassword: {
        en: "Change Profile Password",
        de: "Profilpasswort ändern",
    },
    enterPassword: {
        en: "Enter Password",
        de: "Passwort eingeben",
    },
    change: {
        en: "Change",
        de: "Ändern",
    },
    remove: {
        en: "Remove",
        de: "Entfernen",
    },
    upload: {
        en: "Upload",
        de: "Hochladen",
    },
    mediaName: {
        en: "Media Name",
        de: "Medienname",
    },
    uploadVideo: {
        en: "Upload Video",
        de: "Video hochladen",
    },
    uploadThumbnail: {
        en: "Upload Thumbnail",
        de: "Miniaturbild hochladen",
    },
    updatePwd: {
        en: "Update Password",
        de: "Kennwort aktualisieren",
    },
    savePassword: {
        en: "Save your password",
        de: "Speichern Sie Ihr Passwort",
    },
    savePasswordMessage: {
        en: "Kindly note it down your password, it will not be accessible afterwards again",
        de: "Bitte notieren Sie sich Ihr Passwort, es ist danach nicht mehr zugänglich",
    },
    profile: {
        en: "Profile",
        de: "Profil",
    },
    profileName: {
        en: "Profile name",
        de: "Profilname",
    },
    status: {
        en: "Status text",
        de: "Beschreibung",
    },
    addCompanyProfile: {
        en: "Add company profile",
        de: "Firmenprofil hinzufügen",
    },
    profilePageMessage: {
        en: "Here you can set up the company's official profile for the app. Present your company in the best possible way with a status text, images and videos. Employees can follow the profile in the app and then see all activities of the profile.",
        de: "Hier kannst du das offizielle Profil des Unternehmens für der App einrichten. Stelle dein Unternehmen mit einem Statustext, Bildern und Videos bestmöglich vor. Mitarbeiter*innen können dem Profil in der App folgen und sehen dann alle Aktivitäten des Profils.",
    },
    mediaItemTitle: {
        en: "Upload video",
        de: "Video hochladen",
    },
    domains: {
        en: "Domains",
        de: "Domains",
    },
    customeErrorHandling: {
        en: {
            associationDomainIsTaken: "The domain you want to associate is already taken",
            commonEmailDomain: "This email is a commonly used one and not supported for domain-associations. Please use your own organization-specific domain.",
            invalidEmailFormat: "The given email address does not match the valid email format.",
        },
        de: {
            associationDomainIsTaken: "Die Domain, die Sie zuordnen möchten, ist bereits vergeben.",
            commonEmailDomain: "Diese E-Mail-Adresse wird häufig verwendet und für Domänenzuordnungen nicht unterstützt. Bitte verwenden Sie Ihre eigene organisationsspezifische Domain.",
            invalidEmailFormat: "Die angegebene E-Mail-Adresse entspricht nicht dem gültigen E-Mail-Format.",
        },
    },
    verifiationMailSent: {
        en: "An email has been sent with verification code successfully",
        de: "Eine E-Mail mit dem Bestätigungscode wurde erfolgreich gesendet",
    },
    addNew: {
        en: "Add new",
        de: "Neue hinzufügen",
    },
    delete: {
        en: "Delete",
        de: "Löschen",
    },
    verify: {
        en: "Verify",
        de: "Verifizieren",
    },
    domain: {
        en: "Domain",
        de: "Domain",
    },
    verificationEmail: {
        en: "Varification email",
        de: "Bestätigungs-E-Mail",
    },
    associationStatus: {
        en: "Status",
        de: "Status",
    },
    associationAction: {
        en: "Association action",
        de: "Beitreten",
    },
    associationActions: {
        en: {
            "auto-add": "Automatically",
            none: "In-active",
            request: "By Request",
        },
        de: {
            "auto-add": "Automatisch",
            none: "Inaktiv",
            request: "Auf Anfrage",
        },
    },
    verificationStatus: {
        en: {
            pending: "Pending",
            verified: "Verified",
        },
        de: {
            pending: "Ausstehend",
            verified: "Verifiziert",
        },
    },
    domainAssociations: {
        en: "Allowed domain",
        de: "Erlaubte Domains",
    },
    actions: {
        en: "Actions",
        de: "Aktionen",
    },
    createAssociation: {
        en: "Add new domain",
        de: "Neue Domain hinzufügen",
    },
    editAssociation: {
        en: "How can a user join the organisation?",
        de: "Wie kann ein Nutzer der Organisation beitreten?",
    },
    verifyDomain: {
        en: "Verify domain",
        de: "Domain bestätigen",
    },
    verificationCode: {
        en: "Varification code",
        de: "Bestätigungscode",
    },
    resend: {
        en: "Resend Verification Code",
        de: "Bestätigungscode nochmal versenden",
    },
    deleteMessage: {
        en: (domainAssociation: any) => `Also, would you like to remove all memberships with @${domainAssociation?.domain}?`,
        de: (domainAssociation: any) => `Möchten Sie außerdem alle Mitgliedschaften mit @${domainAssociation?.domain} entfernen?`,
    },
    domainPageMessage: {
        en: "You can allow people with specific email domains to find and join your organization.",
        de: "Sie können Personen mit bestimmten E-Mail-Domains ermöglichen, Ihre Organisation zu finden und ihr beizutreten.",
    },
    deleteOnlyDomain: {
        en: "Delete only domain",
        de: "Nur domain löschen",
    },
    deleteDomainWithMember: {
        en: "Delete domain with all members",
        de: "domain mit allen Mitgliedern löschen",
    },
    demoModeErrorMsg: {
        en: "This feature is not available in demo mode.",
        de: "Dieses Feature ist in der Demo-Phase nicht verfügbar.",
    },
};

export default localize(i18n);
